import React from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { Loader2 } from 'lucide-react';

const DOCS = {
  privacy: { file: '/privacy-policy.md', title: 'Privacy Policy' },
  terms: { file: '/terms-of-use.md', title: 'Terms of Use' },
};

const MdLink = ({ href, children }) => (href?.startsWith('/') ? <Link to={href} className="text-fuchsia-700 underline">{children}</Link>
  : <a href={href} className="text-fuchsia-700 underline" target="_blank" rel="noreferrer">{children}</a>);

export default function PrivacyPolicyPage({ doc = 'privacy' }) {
  const meta = DOCS[doc];
  const [text, setText] = React.useState('');
  const [error, setError] = React.useState(false);
  React.useEffect(() => {
    document.title = `${meta.title} · Girgit by Half Eaten Donut`;
    setText(''); setError(false);
    fetch(meta.file, { cache: 'no-cache' })
      .then((r) => (r.ok ? r.text() : Promise.reject()))
      .then(setText)
      .catch(() => setError(true));
    window.scrollTo(0, 0);
  }, [meta]);
  return (
    <div className="min-h-screen bg-[#f6f6f4]" data-testid={`${doc}-page`}>
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center gap-3">
          <img src="https://customer-assets.emergentagent.com/job_careers-hub-9/artifacts/6q64xjbl_HED%20NEW%20LOGO%20BLACK%20PNG.png" alt="Half Eaten Donut" className="h-7" />
          <span className="text-sm font-semibold text-slate-700 flex-1">Girgit</span>
          <nav className="flex gap-4 text-xs font-semibold">
            <Link to="/privacy" className={doc === 'privacy' ? 'text-slate-900' : 'text-slate-500 hover:text-slate-900'} data-testid="legal-nav-privacy">Privacy</Link>
            <Link to="/terms" className={doc === 'terms' ? 'text-slate-900' : 'text-slate-500 hover:text-slate-900'} data-testid="legal-nav-terms">Terms</Link>
          </nav>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-10">
        {error && <p className="text-rose-600" data-testid={`${doc}-error`}>This page could not be loaded. Please email media@halfeatendonut.in.</p>}
        {!text && !error && <Loader2 className="w-6 h-6 animate-spin text-fuchsia-600" />}
        {text && (
          <article data-testid={`${doc}-content`}
            className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-10 text-[15px] leading-relaxed text-slate-700
              [&_h1]:text-3xl [&_h1]:font-bold [&_h1]:text-slate-900 [&_h1]:mb-4
              [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:mt-8 [&_h2]:mb-3
              [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-3 [&_li]:mb-1.5 [&_strong]:text-slate-900">
            <ReactMarkdown components={{ a: MdLink }}>{text}</ReactMarkdown>
          </article>
        )}
      </main>
    </div>
  );
}
